import React from 'react'
import {localestr} from '../utils.js'
import Edit from './Edit'
import EditList from './EditList'

function Filter({filterData,filter,setFilter}){
    //масив filterdata : ім"я, id, тип значення, значення
    //масив filter : id, тип порівняння, значення, тип значення


    let data=[]
    if(!filterData) filterData=[]
    for (let i=0; i<filterData.length; i++){
        data[i]={...filterData[i],compare:''}
        if (filter!=='' && filter!==undefined){
            for (let j=0; j<filter.length; j++){
                if (filter[j].dataId===filterData[i].dataId) {data[i]={...filterData[i],...filter[j]};break}
            }
        }
    }

    const setCompare=(idx,d)=>{
        let n_filter=data.slice()
        if((n_filter[idx].compare==='nin_f'||n_filter[idx].compare==='in_f')&&(d==='='||d==='<>'||d==='')) setValue(idx,null)
        if((d==='nin_f'||d==='in_f')&&(n_filter[idx].compare==='='||n_filter[idx].compare==='<>')) setValue(idx,null)
        n_filter[idx].compare=d
        setFilter(n_filter)
    }

    const setValue=(idx,d)=>{
        let n_filter=data.slice()
        n_filter[idx].value=d
        setFilter(n_filter)
    }

    const items=data.map((it,idx)=>{
        let opts=''
        let typeVal=it.typeVal
        if(it.compare==='in_f'||it.compare==='nin_f') typeVal='fld'+typeVal.substring(3)
        if (it.typeVal==='text') opts=[<option key='1' value='lk'>{localestr('містить')}</option>,<option key='2' value='nlk'>{localestr('не містить')}</option>]
        else if (it.typeVal==='number' || it.typeVal==='date') opts=[<option key='1' value='>'>{localestr('більше')}</option>,<option key='2' value='<'>{localestr('менше')}</option>]
        else if (it.typeVal==='catGoods' || it.typeVal==='catCounterparties') opts=[<option key='1' value='in_f'>{localestr('в папці')}</option>,<option key='2' value='nin_f'>{localestr('не в папці')}</option>,<option key='3' value='in_l'>{localestr('в списку')}</option>,<option key='4' value='nin_l'>{localestr('не в списку')}</option>]
        
        if(it.compare==='in_l'||it.compare==='nin_l') return <React.Fragment  key={idx}><tr>
                <td>{localestr(it.caption)}</td>
                <td style={{textAlign:'right'}}><select id={idx} style={{width:'95px'}} value={it.compare} onChange={(e)=>{setCompare(idx,e.target.value)}}>
                        <option value=''></option>
                        <option value='='>{localestr('дорівнює')}</option>
                        <option value='<>'>{localestr('не дорівнює')}</option>
                        {opts}
                    </select></td></tr>
                <tr><td colSpan='2' style={{width:'100%',boxSizing:'border-box',paddingBottom:'6px'}}><EditList Value={it.compare?it.value:''} typeVal={typeVal} setVal={(d)=>{setValue(idx,d)}} disabled={it.compare?'':'1'}/></td>
            </tr></React.Fragment>

        return <React.Fragment  key={idx}><tr>
                <td>{localestr(it.caption)}</td>
                <td style={{textAlign:'right'}}><select id={idx} style={{width:'95px'}} value={it.compare} onChange={(e)=>{setCompare(idx,e.target.value)}}>
                        <option value=''></option>
                        <option value='='>{localestr('дорівнює')}</option>
                        <option value='<>'>{localestr('не дорівнює')}</option>
                        {opts}
                    </select></td></tr>
                <tr><td colSpan='2' style={{width:'100%',boxSizing:'border-box',paddingBottom:'6px'}}><Edit Value={it.compare?it.value:''} typeVal={typeVal} setVal={(d)=>{setValue(idx,d)}} disabled={it.compare?'':'1'}/></td>
            </tr></React.Fragment>})

    return(
        <fieldset className='legend'><legend>{localestr('Фільтри')}</legend>
        <table><tbody>{items}</tbody></table>
        </fieldset>
    )
}

export default Filter